import SaveChangesBar from './component';

export default SaveChangesBar;
